import { connect } from "react-redux";

import EndToEndView from "./EndToEndView";
import LadsState from "../lads/LadsState";
import SearchState from "../shipment-search/ShipmentSearchState";
import {
  selectLob,
  selectLocation,
  setSearchStr,
  selectLad,
  toggleLadsPanel
} from "./EndToEndState";

function mapStateToProps(state) {
  const { getLadsList, selectGroupedLads } = LadsState.selectors;
  return {
    ...state.endToEnd,
    ...state.maps,
    locations: state.locations.data,
    ladsList: getLadsList(state),
    ladsGrouped: selectGroupedLads(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    selectLob: ind => dispatch(selectLob(ind)),
    selectLocation: loc => dispatch(selectLocation(loc)),
    selectLad: lad => dispatch(selectLad(lad)),
    setSearchStr: str => dispatch(setSearchStr(str)),
    toggleLadsPanel: toggle => dispatch(toggleLadsPanel(toggle)),
    searchLocation: (locationName, locationID) => {
      dispatch(SearchState.actionCreators.clearSearchFilters());
      dispatch(SearchState.actionCreators.setSearchCategory("location"));
      dispatch(SearchState.actionCreators.setSearch(locationName, locationID));
      dispatch(SearchState.actionCreators.searchShipments({label: locationName, value: locationID}, "location", {}));
      dispatch({ type: "SHIPMENT_SEARCH" });
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EndToEndView);



// WEBPACK FOOTER //
// ./src/modules/end-to-end/EndToEndContainer.js